import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { Layout } from "antd";

import "./AppLayout.scss";

const AppLayout = ({ WrappedComponent }) => {
  const pathname = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Layout className="main-content-layout">
      <Layout.Content>
        <WrappedComponent />
      </Layout.Content>
    </Layout>
  );
};

export default AppLayout;
